import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.SupplierProfile.components.Skills.title',
    defaultMessage: 'Work should be productive and fun!',
  },
  subtitle: {
    id: 'containers.SupplierProfile.components.Skills.subtitle',
    defaultMessage: 'A description of your setup and your capabilities will help us in our task of finding great matches for your voice. Please let us know about your skills and technical setup below.',
  },
  syncLevelNone: {
    id: 'containers.SupplierProfile.components.Skills.syncLevel.none.label',
    defaultMessage: 'None',
  },
  syncLevelNoneHint: {
    id: 'containers.SupplierProfile.components.Skills.syncLevel.none.hint',
    defaultMessage: 'You are not able to sync voice over recordings.',
  },
  syncLevelManuscriptLabel: {
    id: 'containers.SupplierProfile.components.Skills.syncLevel.manuscript.label',
    defaultMessage: 'Manuscript',
  },
  syncLevelManuscriptHint: {
    id: 'containers.SupplierProfile.components.Skills.syncLevel.manuscript.hint',
    defaultMessage: 'You can deliver a recording matching the total time duration of the manuscript length.',
  },
  syncLevelParagraphLabel: {
    id: 'containers.SupplierProfile.components.Skills.syncLevel.paragraph.label',
    defaultMessage: 'Paragraph',
  },
  syncLevelParagraphHint: {
    id: 'containers.SupplierProfile.components.Skills.syncLevel.paragraph.hint',
    defaultMessage: 'You can deliver a recording matching the provided timecodes for the length of the paragraphs in the script. ',
  },
  syncLevelDubbingLabel: {
    id: 'containers.SupplierProfile.components.Skills.syncLevel.dubbing.label',
    defaultMessage: 'Dubbing',
  },
  syncLevelDubbingHint: {
    id: 'containers.SupplierProfile.components.Skills.syncLevel.dubbing.hint',
    defaultMessage: 'Commonly used in news and interviews when an on-screen interview begins in the original language. Volume is then faded and replaced with a local voice, in the translated language, for the duration of the speech.',
  },
  syncLevelLabel: {
    id: 'containers.SupplierProfile.components.Skills.syncLevel.label',
    defaultMessage: 'On what level are you able to sync your voice over recordings?',
  },
  syncLevelLabelHint: {
    id: 'containers.SupplierProfile.components.Skills.syncLevel.label.hint',
    defaultMessage: 'Use slider to select level',
  },
  descriptionLabel: {
    id: 'containers.SupplierProfile.components.Skills.description.label',
    defaultMessage: 'Describe your technical setup',
  },
  descriptionLabelHint: {
    id: 'containers.SupplierProfile.components.Skills.description.label.hint',
    defaultMessage: 'Please include a short and precise description of our microphone and recording setup for our post-production engineers.',
  },
  descriptionPlaceholder: {
    id: 'containers.SupplierProfile.components.Skills.description.placeholder',
    defaultMessage: 'Enter details about your studio, microphone, etc. here',
  },
  descriptionHint: {
    id: 'containers.SupplierProfile.components.Skills.description.hint',
    defaultMessage: '{left} characters left of {max}',
  },
  skillsLabel: {
    id: 'containers.SupplierProfile.components.Skills.skills.label',
    defaultMessage: 'I provide the following services',
  },
  skillsLabelHint: {
    id: 'containers.SupplierProfile.components.Skills.skills.label.hint',
    defaultMessage: 'You must be able to deliver the selected services profficiently.',
  },
  acting: {
    id: 'containers.SupplierProfile.components.Skills.acting.label',
    defaultMessage: 'Acting',
  },
  actingHint: {
    id: 'containers.SupplierProfile.components.Skills.acting.hint',
    defaultMessage: 'You can follow directions and act different characters in the recording based on the script.',
  },
  liveSession: {
    id: 'containers.SupplierProfile.components.Skills.liveSession.label',
    defaultMessage: 'Live Session',
  },
  liveSessionHint: {
    id: 'containers.SupplierProfile.components.Skills.liveSession.hint',
    defaultMessage: 'A real-time conversation (of around 60 mins of duration) between the client and voice talent during the entire recording session, conducted via our \'Live Session tool\'. The voice talent can quickly follow directions and ensure interpretations are correctly adapted.',
  },
  validationFailed: {
    id: 'containers.SupplierProfile.components.Skills.validationFailed',
    defaultMessage: 'Technical setup description is required.',
  },
  setupImageLabel: {
    id: 'containers.SupplierProfile.components.Skills.setupImage.label',
    defaultMessage: 'Upload a photo of your studio setup',
  },
  setupImageLabelHint: {
    id: 'containers.SupplierProfile.components.Skills.setupImage.label.hint',
    defaultMessage: 'Please upload one wide-angle photo of your studio to help us review your technical setup.',
  },
  validationStudioImageFailed: {
    id: 'containers.SupplierProfile.components.Skills.validationStudioImageFailed',
    defaultMessage: 'Setup photo is required.',
  },
  setupImageUploadLabel: {
    id: 'containers.SupplierProfile.components.Skills.setupImageUploadLabel',
    defaultMessage: 'Uploaded Image:',
  },
  setupImageNewUploadDescription: {
    id: 'containers.SupplierProfile.components.Skills.setupImageNewUploadDescription',
    defaultMessage: 'Drag and drop an image here, or click to select one',
  }
})
